import { CLUB_SOFTWARE_NUMBERS } from './software-numbers';

export function isClub(softwareNumber: number | string): boolean {
  if (typeof softwareNumber === 'string') {
    softwareNumber = Number.parseInt(softwareNumber, 10);
  }

  return CLUB_SOFTWARE_NUMBERS.includes(softwareNumber);
}
